import customFetch from '../customFetch';

const API_URL = process.env.VUE_APP_MACHETE_AUTH_API;

const NEW_USER_URL = `${API_URL}/users/with-company`;
const GET_USERS_URL = `${API_URL}/users`;
const CSV_LOAD_URL = `${API_URL}/users/csv-load`;
const UPDATE_USER_URL = `${API_URL}/user`;
const UPDATE_OWN_USER_URL = `${API_URL}/user-own`;
const UPDATE_RFC_URL = `${API_URL}/user/rfc`;
const GET_ALL = `${API_URL}/users-all`;

const NEW_SECONDARY_USER_URL = `${API_URL}/user-secondary/by-main/:id`;
const SEND_SECONDARY_SIGN_IN_URL = `${API_URL}/user-secondary/:id/send-email`;
const UPDATE_SECONDARY_USER_URL = `${API_URL}/user-secondary/:secondary/by-main/:id`;
const DELETE_SECONDARY_USER_URL = `${API_URL}/user-secondary/:secondary/by-main/:id`;
const GET_SECONDARY_USERS_URL = `${API_URL}/users-secondary`;
const GET_SINGLE_SECONDARY_USER_URL = `${API_URL}/user-single-secondary/:secondaryId`;

export default {
  async getUsers(size = 20, page = 1, email, accountNumber) {
    const query = { size, page };

    if (email != null) query.email = email;

    if (accountNumber != null) query.accountNumber = accountNumber;

    const response = await customFetch(GET_USERS_URL, { query });

    const { payload } = await response.json();

    return payload;
  },

  async getAll() {
    const response = await customFetch(GET_ALL, {
      method: 'GET',
    });

    const payload = await response.blob();

    return payload;
  },

  async createUser(data, sendEmail) {
    const response = await customFetch(NEW_USER_URL, {
      method: 'POST',
      body: JSON.stringify(data),
      query: { sendEmail },
    });

    const { payload } = await response.json();

    return payload;
  },

  async createSecondaryUser(data, id) {
    const response = await customFetch(NEW_SECONDARY_USER_URL, {
      method: 'POST',
      body: JSON.stringify(data),
      params: { id },
      errors: [
        { code: 402, message: 'Usuarios máximos alcanzados' },
      ],
    });

    const { payload } = await response.json();

    return payload;
  },

  async sendSecondarySignInEmail(id) {
    const response = await customFetch(SEND_SECONDARY_SIGN_IN_URL, {
      params: { id },
    });

    const { payload } = await response.json();

    return payload;
  },

  async updateSecondaryUser(data, id, secondaryId) {
    const response = await customFetch(UPDATE_SECONDARY_USER_URL, {
      method: 'PUT',
      body: JSON.stringify(data),
      params: { secondary: secondaryId, id },
    });

    const { payload } = await response.json();

    return payload;
  },

  async deleteSingleSecondary(id, secondaryId) {
    const response = await customFetch(DELETE_SECONDARY_USER_URL, {
      method: 'DELETE',
      params: { secondary: secondaryId, id },
    });

    const { payload } = await response.json();

    return payload;
  },

  async getSecondaryUsers(size = 20, page = 1) {
    const query = { size, page };

    const response = await customFetch(GET_SECONDARY_USERS_URL, { query });

    const { payload } = await response.json();

    return payload;
  },

  async getSecondaryUser(secondaryId) {
    const params = { secondaryId };

    const response = await customFetch(GET_SINGLE_SECONDARY_USER_URL, { params });

    const { payload } = await response.json();

    return payload;
  },

  async updateUser(data) {
    const response = await customFetch(UPDATE_USER_URL, {
      method: 'PUT',
      body: JSON.stringify(data),
    });

    const { payload } = await response.json();

    return payload;
  },

  async updateOwnUser(data) {
    const response = await customFetch(UPDATE_OWN_USER_URL, {
      method: 'PUT',
      body: JSON.stringify(data),
    });

    const { payload } = await response.json();

    return payload;
  },

  async updateRfc(data) {
    const response = await customFetch(UPDATE_RFC_URL, {
      method: 'PUT',
      body: JSON.stringify(data),
    });

    const { payload } = await response.json();

    return payload;
  },

  async csvLoad(body) {
    const response = await customFetch(CSV_LOAD_URL, {
      method: 'POST',
      body,
      customContentType: true,
    });

    const { payload } = await response.json();

    return payload;
  },
};
